import { panelLabelReportDate, panelLabelSendBy } from "_constants";
import { ReportStateChip } from "components/shared";
import { Report } from "interfaces";
import { PrimeIcons } from "primereact/api";
import { Divider } from "primereact/divider";
import { formatDataSource } from "utils";

export const ReportDetailPanelHeader = ({ report }: { report: Report }) => {
  
  return (
    <div className="flex-container column gap-12">
      <h3>{report.code}</h3>
      <div className="flex-container align-center gap-8">
        <ReportStateChip type={report.state} />
        <Divider layout="vertical" color="#eeeeee" className="title-divider" />
        <i className={PrimeIcons.USER} />
        <span className="text-base-regular">{panelLabelSendBy}</span>
        <span className="text-base-regular-semibold capitalize">
          {report.createdBy}
        </span>
        <span className="text-base-regular">•</span>
        <i className={PrimeIcons.CALENDAR} />
        <span className="text-base-regular">{panelLabelReportDate}</span>
        <span className="text-base-regular-semibold capitalize">
          {formatDataSource(report.creationDate)}
        </span>
      </div>
    </div>
  );
};
